import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  Col,
  Row,
  Form,
  Button,
  Card,
  CardBody,
  CardFooter,
  Table,
  Badge,
} from "reactstrap";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import APICall from "../../services/apiCall";
import { toast } from "react-toastify";
import AppContext from "../../context/Context";

const PendingDeleteApplication = (props) => {
  const {
    applicationDeleteStatus,
    setOpenDeleteModal,
    applicationData,
    loginUserDetails,
    applicationList,
    setFetchAfterUpdate,
    setFirstStartupApplicationBoolean,
    setSelectedApiNames,
    setApiLimitNote,
    setRefreshAfterDelete,
  } = props;

  const [isDeleteButtpnDisable, setIsDeleteButtpnDisable] = useState(false);
  const [commentByApprover, setCommentByApprover] = useState("");

  const onSubmit = (selectedRequestStatus) => {
    setFetchAfterUpdate(false);
    setRefreshAfterDelete(false);
    if (commentByApprover) {
      let body = {
        request_id: applicationDeleteStatus.request_id,
        app_id: applicationData.app_id,
        approved_by: loginUserDetails.user_name, //[loggedin user username/email],
        comment_from_approver: commentByApprover.trim(),
        request_status: selectedRequestStatus, //optional if we get comment from user then only pass else blank
        devid: loginUserDetails.dev_id,
      };
      setIsDeleteButtpnDisable(true);

      APICall.servertrip(
        "POST",
        "pending_application_delete",
        loginUserDetails,
        undefined,
        body
      )
        .then((res) => {
          setOpenDeleteModal(false);
          setFetchAfterUpdate(true);
          toast.success(res.data?.message);
          if (selectedRequestStatus == "approve") {
            setRefreshAfterDelete(true);
          }
          if (applicationList.length === 1) {
            setFirstStartupApplicationBoolean(false);
            setSelectedApiNames([]);
            setApiLimitNote("");
            setIsDeleteButtpnDisable(true);
          }
        })
        .catch((error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setOpenDeleteModal(false);
          setFetchAfterUpdate(false);
          setIsDeleteButtpnDisable(true);
          setRefreshAfterDelete(false);
        });
    } else {
      setFetchAfterUpdate(false);
      setRefreshAfterDelete(false);
      toast.error("Comment should not be empty.");
    }
  };

  return (
    <>
      <Row>
        <Col>
          <Table bordered borderless striped className="rounded">
            <tbody>
              <tr>
                <td>App Name</td>
                <td>{applicationData.app_name}</td>
              </tr>
              <tr>
                <td>Delete Status</td>
                <td>
                  <Badge color="info">
                    {applicationDeleteStatus.request_status}
                  </Badge>
                </td>
              </tr>
              <tr>
                <td>Request By</td>
                <td>{applicationDeleteStatus.request_by}</td>
              </tr>
              <tr>
                <td>Requester Comment</td>
                <td> {applicationDeleteStatus.comment_from_requester}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

      {loginUserDetails.is_partner == "0" && (
        <>
          {" "}
          <Row>
            <Col>
              <SikkaInput
                label="Comment"
                placeholder="comment by approver"
                id="comment"
                name="comment"
                onChange={(e) => {
                  setCommentByApprover(e.target.value);
                }}
                errors={""}
              />
            </Col>
          </Row>
          <Row className="mt-1 mb-2">
            <Col>
              <Button
                size="sm"
                className="mr-1"
                color="outline-success"
                type="submit"
                disabled={isDeleteButtpnDisable}
                onClick={() => {
                  onSubmit("approve");
                }}
              >
                Approve
              </Button>
              <Button
                color="outline-danger"
                size="sm"
                onClick={() => {
                  onSubmit("deny");
                }}
                disabled={isDeleteButtpnDisable}
              >
                Deny
              </Button>
            </Col>
          </Row>
        </>
      )}

      <Row
        form
        className="modal-footer px-md-3 bg-light"
        style={{
          marginLeft: "-16px",
          marginRight: "-16px",
          marginBottom: "-16px",
        }}
      >
        <Button
          size="sm"
          className="ml-auto"
          color="outline-danger"
          type="submit"
          onClick={() => {
            setOpenDeleteModal(false);
          }}
        >
          Cancel
        </Button>
      </Row>
    </>
  );
};

export default PendingDeleteApplication;
